export default "__VITE_ASSET__D5_mLRXd__"